<template>
  <v-dialog v-model="show" max-width="520" persistent>
    <v-card>
      <v-card-title>{{ $t("finance_new_campaign") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <text-field
            v-model="form.name"
            :label="$t('finance_campaign_name')"
            prependInnerIcon="mdi-gift-outline"
            :rules="[rules.required]"
          />
          <v-row dense>
            <v-col cols="6">
              <date-picker
                v-model="form.periodStart"
                singleDate
                :label="$t('finance_period_start')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="6">
              <date-picker
                v-model="form.periodEnd"
                singleDate
                :label="$t('finance_period_end')"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <text-field
            v-model="form.discount"
            :label="$t('finance_discount_hint')"
            prependInnerIcon="mdi-percent-outline"
            :rules="[rules.required]"
          />
          <dropdown
            v-model="form.fundedBy"
            :items="fundingOptions"
            itemText="label"
            itemValue="value"
            :label="$t('finance_funded_by')"
            icon="mdi-account-cash-outline"
          />
          <v-row dense>
            <v-col cols="6">
              <text-field
                v-model.number="form.orderaShare"
                :label="$t('finance_ordera_share_percent')"
                type="number"
                prependInnerIcon="mdi-percent"
              />
            </v-col>
            <v-col cols="6">
              <text-field
                v-model.number="form.restaurantShare"
                :label="$t('finance_restaurant_share_percent')"
                type="number"
                prependInnerIcon="mdi-percent"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PROMOTION_FUNDING_META } from "../constants";

const emptyForm = () => ({
  name: "",
  periodStart: "",
  periodEnd: "",
  discount: "",
  fundedBy: "restaurant",
  orderaShare: 0,
  restaurantShare: 0,
});

export default {
  name: "PromotionFormDialog",

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
      },
    };
  },

  computed: {
    fundingOptions() {
      return Object.keys(PROMOTION_FUNDING_META).map((value) => ({
        value,
        label: this.$t(PROMOTION_FUNDING_META[value]),
      }));
    },
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.form = emptyForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        name: this.form.name,
        period_start: this.form.periodStart,
        period_end: this.form.periodEnd,
        discount: this.form.discount,
        funded_by: this.form.fundedBy,
        ordera_share: Number(this.form.orderaShare) || 0,
        restaurant_share: Number(this.form.restaurantShare) || 0,
      });
    },
  },
};
</script>
